// Helper function to calculate age from DOB timestamp
export const calculateAge = (dobInput) => {
  if (!dobInput) return "N/A";

  let birthDate;
  try {
    // Firestore Timestamp objects (have a toDate method)
    if (typeof dobInput === "object" && typeof dobInput.toDate === "function") {
      birthDate = dobInput.toDate();
      // Already a JS Date object
    } else if (dobInput instanceof Date) {
      birthDate = dobInput;
      // ISO date string or other string formats
    } else if (typeof dobInput === "string" || typeof dobInput === "number") {
      birthDate = new Date(dobInput);
    }

    // Fallback/validation
    if (!birthDate || isNaN(birthDate.getTime())) {
      return "Invalid DOB";
    }

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age >= 0 ? age.toString() : "N/A";
  } catch (error) {
    console.error("Error calculating age:", error);
    return "Error";
  }
};
